class AudioService {
    constructor($rootScope, $log, wtcpjsClientProviderService, settingsService) {
        this._client = wtcpjsClientProviderService.getClient();
        this._log = $log;
        this._rootScope = $rootScope;
        this._settingsService = settingsService;

        this._rootScope.$on('ConnectionService.login', () => {
            let volume = this._settingsService.getVolume();
            this.adjustVolume(volume);
        });
    }

    adjustVolume(percentScale) {
        this._client.setVolume(percentScale);
    }
}

angular.module('webcomm').service('audioService', ['$rootScope', '$log', 'wtcpjsClientProviderService', 'settingsService', AudioService]);